import * as React from 'react';
import { HiOutlineChevronRight } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import { Flex, Text, Button, Icon, Center, Grid } from '@chakra-ui/react';
import { useAppSelector, useGetCategoriesQuery } from '@spartalabs/pdc-core';
import { Container, EmptyCard, ErrorCard } from 'components';
import { CardSkele } from 'components/Skeletons/Card';
import { FaQSearch } from '../components/Search';

export const FaQ: React.FC = () => {
  const navigate = useNavigate();
  const permissions = useAppSelector(
    state => state.authSlicer.user.permissions,
  );

  const { data, isLoading, isError, refetch } = useGetCategoriesQuery();

  return (
    <Container bg="white">
      <FaQSearch canEdit={permissions?.includes('faq')} />

      {isError ? (
        <ErrorCard border="0px" boxShadow="0px" refetch={refetch} />
      ) : !isLoading &&
        (!data || (data && data.flatMap(items => items?.FAQs)?.length < 1)) ? (
        <EmptyCard mt="100px" border="0px" boxShadow="0px" />
      ) : (
        <Grid
          w="80%"
          mx="auto"
          justifyItems="center"
          gap={6}
          templateColumns={{
            lg: 'repeat(3, 1fr)',
            md: 'repeat(2, 1fr)',
            base: 'repeat(1, 1fr)',
          }}
          mt="40px"
        >
          {!isLoading &&
            data?.map(
              item =>
                item.FAQs.length > 0 && (
                  <Flex
                    key={item.id}
                    borderRadius="4px"
                    align="center"
                    w="100%"
                    justifyContent="space-between"
                    border="1px solid"
                    borderColor="grey.200"
                    p="4px"
                  >
                    <Text textAlign="left" ml="12px" color="text.100">
                      {item.title}
                    </Text>
                    <Center
                      ml="12px"
                      _hover={{ bg: 'grey.300' }}
                      w="44px"
                      as={Button}
                      bg="grey.100"
                      onClick={() =>
                        navigate(
                          `/centraldeduvidas/lista/${item.title.trim()}/${
                            item.id
                          }`,
                        )
                      }
                      borderRadius="4px"
                    >
                      <Icon
                        color="black"
                        aria-label="Mostrar senha"
                        as={HiOutlineChevronRight}
                        h="24px"
                        w="24px"
                        alignSelf="center"
                      />
                    </Center>
                  </Flex>
                ),
            )}

          {isLoading &&
            [0, 1, 2, 3, 4, 5].map(fakeNatty => (
              <CardSkele key={fakeNatty} h="50px" w="100%">
                <></>
              </CardSkele>
            ))}
        </Grid>
      )}
    </Container>
  );
};
